import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import PriceWrapper from "./Price/PriceWrapper";
import MakeWrapper from "./Make/MakeWrapper";
import TuneIcon from '@material-ui/icons/Tune';
import Grid from "@material-ui/core/Grid/Grid";
import ModelWrapper from "./Model/ModelWrapper";
import TrimWrapper from "./Trim/TrimWrapper";
import YearWrapper from "./Year/YearWrapper";
import LocationWrapper from "./Location/LocationWrapper";
import SearchWrapper from "./Search/SearchWrapper";
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';

const useStyles = makeStyles({
    root: {
    },
    filter: {
        borderTop: '1px dashed #3f51b4',
        wmargin: '0 5px',
        paddingBottom: 10,
        paddingTop: 15,
        width: 'calc(100% - 2px)',
        backgroundColor: '#fff',
        zIndex: 1000,
        transition: 'opacity .1s',
        woverflowY: 'scroll',
        woverflowX: 'hidden'
    },
    chips: {
        width: '100%',
        margin: '0 5px',
        marginBottom: -1,
        position: 'relative',
        background: '#fff'
    },
    chipsSticky: {
        margin: 0,
        position: 'fixed',
        top: 0,
        zIndex: 2000,
        paddingLeft: 5,
        paddingTop: 5,
        paddingBottom: 5,
        width: '100%',
        borderBottom: '1px dashed #3f51b4'
    },
    results: {
        position: 'absolute',
        margiRight: 5,
        right: 5,
        top: 5
    },
    btn: {
        borderRadius: 2,
        border: '1px solid #3f51b4',
        color: '#3f51b4',
        padding: '3px 10px 0px 0px',
        cursor: 'pointer',
        fontSize: '0.8rem',
        display: 'inline-block',
    },
    btnActive: {
        borderRadius: 2,
        backgroundColor: '#3f51b4',
        color: '#fff',
    },
    icon: {
        marginRight: 5,
    },
    closeBtn: {
        borderRadius: 2,
        border: '1px solid #3f51b4',
        color: '#3f51b4',
        padding: '6px 10px 6px 6px',
        cursor: 'pointer',
        fontSize: '0.8rem',
        width: 80,
        marginTop: 8,
        marginLeft: 15,
        marginBottom: 0,
    },
    closeBtnIcon: {
        fontSize: '1rem',
        margin: '4px 6px 2px 4px',
    },
    closeBtnText: {
        marginTop: 0,
    },


    search: {
        position: 'absolute',
        right: 60,
        top: 12,
        border: '1px solid #fff',
        padding: '1px 6px 1px 2px',
        borderRadius: 4,
        height: 24,
        cursor: 'pointer',
    },
    searchText: {
        fontSize: '0.9rem!important',
        color: '#fff',
        marginLeft: '30px!important',
        textDecoration: 'none',
        paddingTop: 2
    },
    tuneIcon: {
        position: 'absolute',
        color: '#fff'
    },

});

const useStylesFilter = makeStyles({
    root: {
        padding: '10px 10px 0 10px',
        width: '100%'
    },
    block: {
        margin: '0 15px',
    },
    expand: {
        marginRight: 5,
        cursor: 'pointer'
    },
    makeLabel: {
        width: 45
    },
    makes: {
        marginBottom: 20,
    },
    makesCont: {
        maxHeight: 300,
        overflowY: 'scroll'
    },
    grid: {
        position: 'relative',
        paddingRight: 30
    },
    done: {
        position: 'absolute',
        right: 0
    },
    clear: {
        marginLeft: 0,
        marginTop: 2
    },
    value: {
        borderBottom: '1px dashed #3f51b4',
        color: 'blue',
        textDecoration: 'none'
    },
    ok: {
        borderBottom: '1px dashed #3f51b4',
        color: 'blue',
        textDecoration: 'none'
    },
    cutText: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        height: '1.5em',
        whiteSpace: 'nowrap'
    }
});

export default function FilterFormMobile(props) {

    const [showFilter, setShowFilter] = React.useState(!!props.filter.params.mobileFilterExpanded);
    const [scrolledOnce, setScrolledOnce] = React.useState();

    const classes = useStyles();
    const filterClasses = useStylesFilter();

    const [sticky, setSticky] = React.useState(false);
    const [top, setTop] = React.useState(0);

    const headerRef = React.createRef();

    const params = props.filter.params;

    const handleFilterClick = () => {
        props.filter.params.mobileFilterExpanded = !showFilter;
        const toShow = !props.filter.params.mobileFilterExpanded;
        if (!toShow) {
            setScrolledOnce(false);
        } else {
            window.scrollTo(0, 0);
        }


        /*const toShow = !props.filter.params.mobileFilterExpanded;
        const items = document.getElementsByClassName('antiFilter');
        for (let item of items) {
            item.style.visibility = toShow ? 'visible' : 'hidden';
            item.style.maxHeight =  toShow ? 'none' : 0;
        }
        const displayableItems = document.getElementsByClassName('antiFilterDisplayable');
        for (let item of displayableItems) {
            item.style.display = toShow ? 'block' : 'none';
        }*/
        props.handleShowFilter(!showFilter);
        setShowFilter(!showFilter);
        handleScroll();
    };


    const handleScroll = () => {
        if (headerRef.current) {

            if (headerRef.current.getBoundingClientRect().top < 0) {

                if (!sticky) {
                    setSticky(true);
                }
            }

            if (window.scrollY < top) {
                if (sticky) {
                    setSticky(false);
                }
            }
        }
    };

    React.useEffect(() => {
        if (headerRef.current && !top) {
            setTop(headerRef.current.getBoundingClientRect().y);
        }
        document.removeEventListener('scroll', handleScroll);
        document.addEventListener('scroll', handleScroll);

        if (showFilter && !scrolledOnce) {
            console.log(window.scrollY);
            window.scrollTo(0, 0);
            if (window.scrollY === 0) {
                setScrolledOnce(true);
            }
        }
    });

    return (<>
            <div ref={headerRef}> </div>
        <div className={classes.search} onClick={handleFilterClick}>
            <TuneIcon className={classes.tuneIcon}/>
            <Typography className={classes.searchText}>Search</Typography>
        </div>
        {sticky && !showFilter ?
            <div className={clsx(classes.chips, sticky ? classes.chipsSticky : null)}>
                <div className={clsx(classes.btn, showFilter ? classes.btnActive : null)}
                                        onClick={handleFilterClick}>
                    <Grid container><Grid item><TuneIcon className={classes.icon}/></Grid>
                        <Grid><Typography>Search</Typography></Grid></Grid>
                </div>
                {showFilter ?
                    <div className={classes.results}><Typography>Results: <b>{params.total}</b></Typography></div>
                    : null}
            </div> : null}

        <div className={classes.filter} style={{
            opacity: showFilter ? 1 : 0,
            minHeight: showFilter ? window.screen.height - 100 : 0,
            display: showFilter ? 'block' : 'none',
        }}>
            {showFilter ? <>
                <LocationWrapper filter={props.filter} isMobile={true} classes={filterClasses}/>
                <YearWrapper filter={props.filter} isMobile={true} classes={filterClasses}/>
                <MakeWrapper filter={props.filter} isMobile={true} classes={filterClasses}/>
                <ModelWrapper filter={props.filter} isMobile={true} classes={filterClasses}/>
                <TrimWrapper filter={props.filter} isMobile={true} classes={filterClasses}/>
                <PriceWrapper filter={props.filter} isMobile={true} classes={filterClasses}/>
                <SearchWrapper filter={props.filter} isMobile={true} classes={filterClasses}/>
                <div className={classes.closeBtn} onClick={handleFilterClick}>
                    <Grid container><Grid item><DoneOutlineIcon className={classes.closeBtnIcon}/></Grid>
                        <Grid><Typography className={classes.closeBtnText}>Done</Typography></Grid></Grid>
                </div>
            </> : null}
        </div>

    </>)
}